import { render, staticRenderFns } from "./TransportOrderAdd.vue?vue&type=template&id=2a2630e6"
import script from "./TransportOrderAdd.vue?vue&type=script&lang=js"
export * from "./TransportOrderAdd.vue?vue&type=script&lang=js"
import style0 from "./TransportOrderAdd.vue?vue&type=style&index=0&id=2a2630e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports